import { Icon } from "@chakra-ui/react";
const WhiteRefreshIcon = () => {
  return (
    <>
      <Icon
        width="4"
        height="4"
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M13.0194 5.79395H13.2759C13.6772 5.79395 14 5.47112 14 5.06985V1.20799C14 0.915334 13.825 0.649831 13.5535 0.538199C13.2819 0.426567 12.9712 0.486909 12.763 0.695087L11.5079 1.95019C8.86493 -0.659581 4.60783 -0.65053 1.97996 1.98036C-0.659986 4.62031 -0.659986 8.89852 1.97996 11.5385C4.6199 14.1784 8.89812 14.1784 11.5381 11.5385C11.9152 11.1613 11.9152 10.5489 11.5381 10.1717C11.1609 9.7946 10.5485 9.7946 10.1713 10.1717C8.28565 12.0574 5.22935 12.0574 3.34368 10.1717C1.458 8.28606 1.458 5.22976 3.34368 3.34408C5.2203 1.46746 8.25247 1.45841 10.1412 3.31391L8.90114 4.55695C8.69296 4.76513 8.63262 5.07589 8.74425 5.34742C8.85588 5.61896 9.12138 5.79395 9.41404 5.79395H13.0194Z"
          fill="white"
        />
      </Icon>
    </>
  );
};
export default WhiteRefreshIcon;
